<template>
  <div class="card-box publish">
    <div class="card-header border-none">发布资源需求</div>
    <div class="card-main" v-loading="loading">
      <el-input v-model="textarea" :rows="5" resize="none" type="textarea" placeholder="请输入您需要的资源内容（最好一句话说清楚）" />
      <div class="btn-publish" @click="AddDemand">立即发布</div>
    </div>
  </div>
</template>

<script>
import {Message, StandardService} from '@/service';

export default {
  data() {
    return {
      textarea: '',
      loading: false,
    }
  },
  methods: {
    async AddDemand() {
      if (!this.textarea) {
        Message.warning('需求内容不能为空');
        return false;
      }
      this.loading = true;
      const res = await StandardService.AddDemand(this.textarea);
      this.loading = false;
      this.textarea = '';
      if (res) {
        this.$parent.resetPublishList();
      }
    }
  }
}
</script>

<style lang="less" scoped>
.card-box {
  background-color: #fff;
  font-family: Source Han Sans CN;

  .card-header {
    height: 38px;
    border-bottom: 1px solid rgba(214, 214, 214, 0.5);
    font-size: 16px;
    font-weight: bold;
    color: #2f3848;
    line-height: 38px;
    box-sizing: border-box;
    padding-left: 14px;
    &.border-none {
      border-bottom: none;
    }
  }

  .card-main {
    padding: 0 14px;
  }
}
.publish {
  flex-shrink: 0;
  margin-right: 9px;
  width: 335px;
  height: 100%;
  /deep/ textarea {
    border-color: rgba(214, 214, 214, 0.5);
    border-radius: 0;
    height: 170px;
  }
  .btn-publish {
    cursor: pointer;
    margin-top: 11px;
    width: 120px;
    height: 30px;
    background: #0989c5;
    line-height: 30px;
    text-align: center;
    color: #fff;
  }
}
</style>
